import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../Navbar";
import Header from "../Header";
import baseUrl from "../BaseUrl";
import Loader from "../Loader";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate, Link } from 'react-router-dom';
import formatDateTimeToPST from '../PSTDateConvert';
import Pagination from 'react-js-pagination';


const DailyOrderList = () => {
    const [name, setName] = useState('');
    const [timeZone, setTimeZone] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [cid, setCid] = useState('');
    const [popupOpen, setPopupOpen] = useState(false);
    const [importHistory, setOrderHistory] = useState([])
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [searchDate, setSearchDate] = useState("");
    const [searchEndDate, setSearchEndDate] = useState("");
    const [displayDate, setDisplayDate] = useState("");
    const [displayEndDate, setDisplayEndDate] = useState("");
    const [selectedCompany, setSelectedCompany] = useState(0);
    const [company, setCompany] = useState([]);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [overlappingDols, setOverlappingDols] = useState([]);
    const [selectedDols, setSelectedDols] = useState([]);


    const navigate = useNavigate();    

    useEffect(() => {
        refreshToken();
        getUserAccess();
        getUserCompany();
    }, []);

    useEffect(() => {
        if (access.length > 0 && token) {
            checkAccess(access, token);
        }
    }, [access, token]);

    useEffect(() => {
        getDailyOrderListHistory();
    }, [page]);

    const getUserCompany = async () => {
        
        const response = await axiosJWT.get(`${baseUrl}/active-user-company`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        const company = response.data.filter(item => item.id !== 1);
        // company.shift();
        // console.log(response.data);
        setCompany(company);
    }

    const handlePageChange = (pageNumber) => {
        // console.log(`active page is ${pageNumber}`);
        setPage(pageNumber);
    }

    const getDailyOrderListHistory = async () => {
        setPopupOpen(true);
        const response = await axiosJWT.get(`${baseUrl}/daily-order-list-history?page=${page}&limit=${20}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        console.log(response.data);
        setPopupOpen(false);
        setOrderHistory(response.data.data)
        setTotalItem(response.data.totalItem)
    }
    

    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);

            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            console.log(decoded.exp);
            setCid(decoded.cid);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
            setTimeZone(decoded.timezone)

        } catch (error) {

            if (error.response) {
                // setError("Unauthorized");
                navigate("/");
                window.location.reload();
            }
        }
    }

    const getUserAccess = async () => {
        try {
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            console.log(response.data.results);
            setAccess(response.data.results);
            // setIsLoading(false);

        } catch (error) {
            console.log(error);

        }
    }    

    const hasPermission = (permission) => {
        return access.some((item) => item.access === permission);
    };

    const checkAccess = async (access) => {
        if (role > 2 || !hasPermission('dolaccess')) {
            navigate('/dashboard');
        }
    }

    const handleSearchDate = (date) => { 
        console.log(date);  
        const formattedDate =
        date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
         date.getDate().toString().padStart(2, '0');
      
         
        setSearchDate(formattedDate);
       
        setDisplayDate(date);
    };

    const handleSearchEndDate = (date) => { 
        console.log(date);  
        const formattedDate =
        date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
         date.getDate().toString().padStart(2, '0');
      
         
        setSearchEndDate(formattedDate);
        setDisplayEndDate(date);
    };

    const handleSearchSubmit = async () => {
        if(!searchDate && !searchEndDate){
            alert("Please select a date");
            return;
        }
        setPopupOpen(true);
        try {
            const response = await axiosJWT.get(`${baseUrl}/daily-order-list/check-history-overlap`, {
                params: { searchDate, searchEndDate },
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data.data && response.data.data.length > 0) {
                setOverlappingDols(response.data.data);
            } else {
                runDolProcess();
            }
        } catch (error) {
            console.error("Error checking for overlap:", error);
            alert("Failed to check for overlapping DOLs.");
        } finally {
            setPopupOpen(false);
        }
    };

    const runDolProcess = async (selectedDolIds = [], allOverlappingDolIds = []) => {
        setPopupOpen(true);
        setButtonDisabled(true);
        console.log(selectedCompany, searchDate, searchEndDate, selectedDolIds, allOverlappingDolIds)
        try {
            await axiosJWT.post(`${baseUrl}/daily-order-list`, {
                company_id: selectedCompany,
                searchDate: searchDate,
                searchEndDate: searchEndDate,
                selectedDolIds,
                allOverlappingDolIds
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            alert("DOL Process Started Successfully");
            window.location.reload();
        } catch (error) {
            console.error("Error starting DOL process:", error);
            alert("Failed to start DOL process.");
            setButtonDisabled(false);
        } finally {
             setPopupOpen(false);
        }
    };

    const handleIncludeAndRunDol = async () => {
        const allOverlappingDolIds = overlappingDols.map(d => d.id);
        runDolProcess(selectedDols, allOverlappingDolIds);
    };

    const handleDolCheckboxChange = (dolId) => {
        setSelectedDols(prev => 
            prev.includes(dolId) 
                ? prev.filter(id => id !== dolId) 
                : [...prev, dolId]
        );
    };


    const handleComapnyChange = (e) => {
        setSelectedCompany(e.target.value);
        // setPage(1);
        // console.log(e.target.value);
        // getUsers(page,e.target.value, selectedUserType); // Reset page to 1 when filter changes
    };

    const clearFilter = () => {
        setSearchDate("");
        setSearchEndDate("");
        setDisplayDate("");
        setDisplayEndDate("");
        setSelectedCompany(0);       
    }

    const handleNavigation = (e, item) => {
        e.preventDefault();
        navigate(`/view-daily-order-detail/${btoa(item.title)}`, { state: item });
    };

    const axiosJWT = axios.create();

    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setCid(decoded.cid);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    function extractDateFromTitle(title) {
        // Regex for "YYYY-MM-DD_to_YYYY-MM-DD"
        // Captures start date in group 1, and end date in group 2
        const rangeRegex = /(\d{4}-\d{2}-\d{2})_to_(\d{4}-\d{2}-\d{2})/;
        // Regex for "YYYY-MM-DD" at the beginning of the string
        const singleDateRegex = /^(\d{4}-\d{2}-\d{2})/;

        // Regex for "YYYYMMDD" at the beginning of the string
        const yyyymmddRegex = /^(\d{4})(\d{2})(\d{2})/;

        let match = title.match(rangeRegex);
        if (match) {
          // For ranges, return an object with startDate, endDate, and the display string
          return `${formatDateTimeToPST(match[1], timeZone, role)} - ${formatDateTimeToPST(match[2], timeZone, role)}`;                  
        }

        match = title.match(singleDateRegex);
        if (match) {
            
          // For single dates, return an object with the date and its PST formatted display string
          return formatDateTimeToPST(match[1], timeZone, role);          
        }
        match = title.match(yyyymmddRegex); // Check for YYYYMMDD format
        if (match) {
            const year = match[1];
            const month = match[2];
            const day = match[3];
            const formattedDate = `${year}-${month}-${day}`; // Convert YYYYMMDD to YYYY-MM-DD
            return formatDateTimeToPST(formattedDate, timeZone, role); // Format for display
        }
      }

    return (
        <div className="panelbox">
            <Navbar token={token} access={access} />
            <div className="right-panel">
                <Header name={name} />
                {popupOpen && (
                    <Loader />
                )}
                <div className="content-page">

                    <div className="row">
                        <div className="col-8">
                            <div className="left-title">
                                <h1>Daily Order List (DOL)</h1>
                            </div>
                        </div>

                        <div className="col-4 top-right-buttons">
                            <div className="export-btn addnew-button"><Link to="/number-management"><span>&larr;</span> Back</Link></div>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-8 order-filter  transection-filter">
                            <div className="boxinput">
                                {/* <select className="company-name form-control" name="company" value={selectedCompany} onChange={handleComapnyChange}>
                                    <option value={0} >Company</option>
                                    {company.map((comp, index) => (
                                        <option key={index} value={comp.id}>
                                          {comp.cname}
                                        </option>
                                    ))}
                                </select> */}
                                <DatePicker
                                    selected={displayDate}
                                    onChange={handleSearchDate}
                                    dateFormat="MM/dd/yyyy" // Set the desired date format
                                    placeholderText="Date"
                                    className="from-date"
                                />
                                <DatePicker
                                    selected={displayEndDate}
                                    onChange={handleSearchEndDate}
                                    dateFormat="MM/dd/yyyy" // Set the desired date format
                                    placeholderText="To Date"
                                    className="end-date"
                                />     
                             
                                <button  className={buttonDisabled || importHistory.some(item => item.status ==1) ? 'search-btn disabled-link' : 'search-btn'}  style={{"marginLeft":"15px"}} onClick={handleSearchSubmit}>Submit</button>
                               { (selectedCompany || searchDate  || searchEndDate) && (<a className='search-btn clear-btn' onClick={clearFilter} >Clear</a>)}
                            </div>
                        </div>
                        
                    </div>
                    {/* Overlapping DOLs Modal */}
                    {overlappingDols.length > 0 && (
                        <div className="common-white-shadow-background setting-section" style={{ marginBottom: '20px', border: '2px solid #f0ad4e', backgroundColor: '#fcf8e3' }}>
                            <div className="row">
                                <div className="col-12">
                                    <h3 style={{ color: '#8a6d3b' }}>⚠️ Overlapping DOL Records Found</h3>
                                    <p>The selected date range overlaps with existing DOL records. Select which previous DOL runs to consider and in the new DOL run exclude any orders which were already reported in the selected previous DOL runs.</p>
                                    <table className="tablebox search-result-table">
                                        <thead>
                                            <tr>
                                                <th>Consider</th>
                                                <th>Title</th>
                                                <th>Created By</th>
                                                <th>Date Range</th>
                                                <th>Created At</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {overlappingDols.map((dol, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedDols.includes(dol.id)}
                                                            onChange={() => handleDolCheckboxChange(dol.id)}
                                                        />
                                                    </td>
                                                    <td>{dol.title}</td>
                                                    <td>{dol.full_name}</td>
                                                    <td>{formatDateTimeToPST(dol.start_date, timeZone, role)} to {formatDateTimeToPST(dol.end_date, timeZone, role)}</td>
                                                    <td>{formatDateTimeToPST(dol.created_at, timeZone, role)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div style={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
                                        <button
                                            className="search-btn"
                                            style={{ margin: 0 }}
                                            onClick={handleIncludeAndRunDol}
                                            disabled={buttonDisabled}
                                        >
                                            {selectedDols.length > 0 ? 'Consider Selected & Run DOL' : 'Run DOL Without Including'}
                                        </button>
                                        <button
                                            className="search-btn clear-btn"
                                            style={{ width: 'auto', margin: 0 }}
                                            onClick={() => { setOverlappingDols([]); setSelectedDols([]); }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="common-white-shadow-background setting-section">
                        <div className="row">
                            <div className=" setting-section haft-whitebox">
                                <table className="tablebox search-result-table">
                                    <thead>
                                        <tr>
                                            <th>Search Date ({timeZone})</th>
                                            <th>Created Date ({timeZone})</th>
                                            <th>Name</th>
                                            <th>Company</th>
                                            <th>Result</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {importHistory.map((importItem, index) => (
                                            <tr key={index}>
                                                <td>{extractDateFromTitle(importItem.title)}</td>
                                                <td>{formatDateTimeToPST(importItem.created_at, timeZone, role)}</td>
                                                <td>{importItem.full_name}</td>
                                                <td>{importItem.cname}</td>
                                                {/* <td>
                                                    {importItem.status == 2 ? <button onClick={() => { getExportResult(importItem.title)}}>  
                                                        <img src={`${process.env.PUBLIC_URL}/images/download.png`} alt="" />

                                                    </button>: "In-Progress"}
                                                </td> */}
                                                <td>
                                                    {importItem.status == 2 ? <a href="#" onClick={(e) => handleNavigation(e, importItem)}>View Result</a>: "In-Progress"}
                                                </td>
                                            </tr>))}
                                    </tbody>
                                </table>

                                {totalItem > 20 && (<Pagination
                                    activePage={page}
                                    itemsCountPerPage={20}
                                    totalItemsCount={totalItem}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange.bind(this)}
                                />)}

                            </div>
                        </div>
                    </div>

                </div>


            </div>
        </div>
    )
}

export default DailyOrderList